import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  const loadMe = () =>
    api.get("/auth/me").then((res) => setUser(res.data)).catch(() => {
      localStorage.removeItem("gir_token");
      setUser(false);
    });

  useEffect(() => {
    const token = localStorage.getItem("gir_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    loadMe().finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("gir_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const applyToken = async (token) => {
    localStorage.setItem("gir_token", token);
    await loadMe();
  };

  const changePassword = async (current_password, new_password) => {
    await api.post("/auth/change-password", { current_password, new_password });
    await loadMe();
  };

  const logout = () => {
    localStorage.removeItem("gir_token");
    setUser(false);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, applyToken, changePassword, logout, refreshUser: loadMe, isAdmin: !!user?.is_admin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
